import axios from '../../axios'

export function trackerGetStarted(trackerid) {
  return async (dispatch) => {
    try {
      const response = await axios.get(`Trackers/${trackerid}/started`)
      dispatch({
        type: 'TRACKERS_TOUR_START',
        payload: {
          data: { id: trackerid, info: response.data },
          error: null,
        },
      })
    } catch (error) {
      dispatch({
        type: 'TRACKER_STARTED_REJECTED',
        payload: {
          message: error.message,
          name: error.name,
        },
      })
    }
  }
}
